<app-header [fixed]="true" *ngIf="showHeaderFooter">
    <div class="container">
        <a class="navbar-brand" routerLink="/"><img src="/assets/img/brand/logo-home.svg"/></a>
        <button type="button" (click)="toggleHambergerMenu()" class="navbar-toggler btn-menu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <ul class="nav navbar-nav">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']" [routerLinkActive]="'inactive-top-menu'"
                    [routerLinkActiveOptions]="{exact: true}">BROWSE</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="https://trofaco.org/" target="_blank" rel="noopener">LEARN MORE</a>
            </li>
            <li class="nav-item" *ngIf="appConfig.showPlantTreesButton">
                <a class="nav-link" href="{{appConfig.plantTreesURL}}" target="_blank" rel="noopener">PLANT TREES</a>
            </li>
        </ul>
    </div>
</app-header>

<div class="app-body" [class.frontend-bg]="showBackgroundImage">
    <!-- Main content -->
    <main class="main">
        <!-- Breadcrumb -->
        <div [className]="routeClass">
            <router-outlet></router-outlet>
        </div><!-- /.container-fluid -->
    </main>
</div>

<div class="app-footer" *ngIf="showHeaderFooter">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <h4>INFORMATION</h4>
                <ul class="list-unstyled">
                    <li><a href="https://trofaco.org/documentation/" target="_blank" rel="noopener">Documentation</a></li>
                    <li><a href="https://trofaco.org/contact/" target="_blank" rel="noopener">Contact</a></li>
                    <li><a href="https://trofaco.org/privacy-policy/" target="_blank" rel="noopener">Privacy policy</a></li>
                    <li><a href="https://trofaco.org/terms-and-conditions/" target="_blank" rel="noopener"> Terms and conditions</a></li>
                </ul>
            </div>
            <div class="col-md-6 col-lg-4">
                <h4>CONTACT</h4>
                <p>
                    Elmebo 28<br/>DK-2300 Copenhagen S<br/>Denmark<br/>
                    <a style="padding: unset" href="tel:+45-7179-1133">(+45) 7179 1133</a>
                </p>
            </div>
            <div class="col-md-6 col-lg-4">
                <h4>NEWSLETTER</h4>
                <p>
                    Follow our newsletter for news and<br/>updates on our work for climate action
                </p>
                <a class="btn btn-primary btn-lg" style="display: inline-block; padding-top: 0.65rem" href="https://trofaco.org/contact/newsletter-sign-up/" target="_blank"
                   rel="noopener">SIGN UP</a>
            </div>
        </div>

    </div>
    <div class="container-fluid copyright">
        <div class="row">
            <div class="col-12">
                <p>COPYRIGHT © TROFACO 2018</p>
            </div>
        </div>
    </div>
</div>
